import { supabase } from './supabase';

export interface IFavorite {
  id: string;
  user_id: string;
  property_id: string;
  created_at: string;
}

const table = 'user_favorites' as const;

export const FavoritesService = {
  async getFavorites(user_id: string): Promise<string[]> {
    try {
      const res = await (supabase as any)
        .from(table)
        .select('property_id')
        .eq('user_id', user_id);

      const data = res?.data as Array<{ property_id: string }> | null;
      return (data || []).map((d) => d.property_id);
    } catch (error) {
      console.error('Failed to fetch favorites', error);
      return [];
    }
  },

  async addFavorite(user_id: string, property_id: string) {
    try {
      const res = await (supabase as any).from(table).insert({ user_id: user_id, property_id: property_id });
      if (res?.error) throw res.error;
      return res?.data;
    } catch (error) {
      throw error;
    }
  },

  async removeFavorite(user_id: string, property_id: string) {
    try {
      const res = await (supabase as any).from(table).delete().match({ user_id: user_id, property_id: property_id });
      if (res?.error) throw res.error;
      return res?.data;
    } catch (error) {
      throw error;
    }
  },
};
